module.exports = __webpack_public_path__ + "img/2-ru.804c6397.jpg";